// Скелет защищённой области — один на все разделы (ПРАВИЛА.md, правило 1): слева полоса
// разделов, правее область раздела. Колонки списка и детали кладут сами модули через
// ListPane и DetailPane; каркас даёт сетку, Outlet и стопку панелей поверх.

import { useEffect } from 'react';

import { Outlet, useLocation } from 'react-router';

import { useRealtimeChannel } from '@/shared/notifications/queries';
// Побочный эффект: панель уведомлений объявляет себя каркасу. Импорт здесь, а не в разделе,
// потому что уведомления открываются из любого места, а не из одного раздела.
import '@/shared/notifications/register';

import { ПодсказкиНаЭкране } from '@/shared/hints/Подсказка';

import { DemoBanner } from './DemoBanner';
import { PanelStack } from './PanelStack';
import { SectionRail } from './SectionRail';
// Панели «Что нового» и «История обновлений» объявляют себя каркасу при загрузке модуля.
import { useРассказОбОбновлении } from './ЧтоНового';

/** Выбрана ли строка списка. Адрес и есть состояние экрана: `/люди/реестр/r/<кто>`. */
const ЕСТЬ_СТРОКА = /\/r\/[^/]+/;

export function AppShell() {
  const location = useLocation();

  // Признак уезжает на корень страницы, а не в состояние компонента, потому что решает он
  // РАСКЛАДКУ: в узком окне помещается одна поверхность за раз — список ИЛИ карточка. Веткой
  // в коде это означало бы перестроение всего дерева при каждом переходе по списку; атрибутом
  // — перекладку стилей, о которой React не знает.
  useEffect(() => {
    const корень = document.documentElement;
    if (ЕСТЬ_СТРОКА.test(location.pathname)) {
      корень.dataset.строка = 'есть';
    } else {
      delete корень.dataset.строка;
    }
  }, [location.pathname]);

  // Живой канал поднимается один раз на сеанс и не привязан к экрану: подписка, заведённая
  // в компоненте списка, умирала бы при переходе в другой раздел — и человек переставал бы
  // узнавать о новом ровно тогда, когда занят другим делом.
  useRealtimeChannel();

  // После установки новой версии — один раз «Что нового в X». Здесь, а не в корне приложения:
  // рассказ нужен тому, кто уже вошёл, и с протухшей сессией он дождётся входа.
  useРассказОбОбновлении();

  return (
    // Полоса «демо» стоит НАД полосой разделов, а не внутри области раздела: она про весь
    // сеанс, а не про экран, и уехать вместе с прокруткой содержимого не имеет права.
    <ПодсказкиНаЭкране>
      {/* Слишком узкое окно: честный ответ вместо каши.
          Правило 10 просит назвать ПРИЧИНУ и следующий шаг, а не сообщить «не поддерживается».
          Появляется это ровно в одном случае — приложение открыли поверх другого узкой
          полосой; на самом планшете, даже в книжной ориентации, места хватает. */}
      <div className='hidden h-full w-full flex-col items-center justify-center gap-3 bg-bg-weak-50 px-6 text-center мало:flex'>
        <p className='text-label-md text-text-strong-950'>Здесь слишком узко для кабинета</p>
        <p className='max-w-xs text-paragraph-sm text-text-sub-600'>
          В такую полосу не помещается даже фамилия с меткой, а ведомость — тем более.
          Разверните окно на половину экрана или на весь.
        </p>
      </div>

      <div className='flex h-full w-full flex-col overflow-hidden bg-bg-white-0 text-text-strong-950 мало:hidden тач:безопасно-сверху'>
        <DemoBanner />
        <div className='flex min-h-0 flex-1 overflow-hidden'>
          <SectionRail />
          <div className='relative flex min-w-0 flex-1 overflow-hidden'>
            <Outlet />
            <PanelStack />
          </div>
        </div>
      </div>
    </ПодсказкиНаЭкране>
  );
}
